import { createFileRoute, notFound } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { parseYearSlug } from "@/lib/calendar/dates";
import { CutiBersamaPage } from "@/components/pages/CutiBersamaPage";
import { getHolidaysForYear } from "@/data/holidays";
import { itemListSchema, breadcrumbSchema, ldScripts } from "@/lib/seo/schema";

export const Route = createFileRoute("/cuti-bersama/$year")({
  loader: ({ params }) => {
    const y = parseYearSlug(params.year);
    if (!y) throw notFound();
    return { y };
  },
  head: ({ loaderData }) => {
    const y = loaderData?.y ?? "";
    const events = typeof y === "number"
      ? getHolidaysForYear(y).filter((h) => h.type === "cuti-bersama").map((h) => ({
          name: h.name, date: h.date, description: `Cuti bersama Indonesia ${y}.`,
          url: `/cuti-bersama/${y}`,
        }))
      : [];
    return {
      meta: [
        { title: `Cuti Bersama ${y} - Daftar Tanggal Resmi SKB 3 Menteri` },
        { name: "description", content: `Daftar lengkap cuti bersama Indonesia ${y} sesuai SKB 3 Menteri: cuti lebaran, cuti Idul Fitri, cuti Natal, cuti tahun baru, dan cuti hari raya lainnya.` },
        { name: "keywords", content: `cuti bersama ${y}, libur lebaran ${y}, cuti lebaran ${y}, libur idul fitri ${y}, cuti natal ${y}` },
        { property: "og:title", content: `Cuti Bersama ${y}` },
        { property: "og:description", content: `Tanggal resmi cuti bersama Indonesia ${y} berdasarkan SKB 3 Menteri.` },
      ],
      scripts: typeof y === "number" ? ldScripts([
        breadcrumbSchema([
          { name: "Beranda", url: "/" },
          { name: `${y}`, url: `/${y}` },
          { name: `Cuti Bersama ${y}`, url: `/cuti-bersama/${y}` },
        ]),
        events.length > 0 ? itemListSchema(events, "id") : null,
      ].filter(Boolean) as unknown[]) : [],
    };
  },
  component: CutiPage,
  notFoundComponent: () => (
    <SiteShell>
      <div className="py-16 text-center"><h1 className="text-2xl font-bold">Tahun tidak valid</h1></div>
    </SiteShell>
  ),
});

function CutiPage() {
  const { y } = Route.useLoaderData();
  return <CutiBersamaPage y={y} />;
}